module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-ism-53515e15441db24b8462f18cdc38e8cc.png";